import styled from 'styled-components';

export const UiCheckbox = styled.div`
	margin-top: 4px;
	min-width: 0;
	flex: 1 1 auto;
	margin-bottom: 4px;

	& > label {
		display: flex;
		align-items: baseline;
		padding: 8px 0;
		width: 100%;
		height: 100%;
		font-size: 1.5rem;
		cursor: pointer;
	}
`;
export const UiCircleCheckbox = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	flex-direction: row-reverse;
	width: 100%;
	color: #000;

	& > input[type=checkbox] {
		position: absolute;
		visibility: hidden;
	}

	& > label {
		position: relative;
		display: flex;
		font-size: 1.5rem;
		font-weight: 300;
		-webkit-transition: all 0.25s linear;
		cursor: pointer;
	}

	.check {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		display: block;
		margin: auto;
		width: 2rem;
		height: 2rem;
		border: 5px solid #fff;
		border-radius: 100%;
		box-shadow: 1px 2px 5px 1px rgba(0, 0, 0, 0.3);
		-webkit-transition: border 0.25s linear;
		transition: border 0.25s linear;
	}

	& > label .checkBox {
		position: relative;
		margin-right: 1rem;
		min-width: 25px;
	}

	& > label .checkBox .check::before {
		position: absolute;
		top: 0;
		left: 0;
		display: block;
		margin: auto;
		width: 1rem;
		height: 1rem;
		border-radius: 100%;
		-webkit-transition: background 0.25s linear;
		transition: background 0.25s linear;
		content: '';
	}

	input[type=checkbox]:checked ~ label {
		.checkBox {
			& > .check::before {
				background: #00923f;
			}
		}
	}
`;
